import ROUTE_NAMES from '@/app/admin/router/router-const';

export default [
  {
    path: 'cbr_updates',
    name: ROUTE_NAMES.CBR_UPDATES,
    component: () => import('../CbrUpdatesPage.vue'),
  }
];